import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function VerifyEmail() {
  const API_BASE = import.meta.env.VITE_API_BASE_URL;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState({
    loading: true,
    ok: false,
    message: "Verifying your email...",
  });

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setStatus({
        loading: false,
        ok: false,
        message: "Missing verification token.",
      });
      return;
    }

    async function verifyEmail() {
      try {
        const res = await axios.post(`${API_BASE}/api/users/verify-email`, {
          token,
        });

        // Save auth data
        localStorage.setItem("userToken", res.data.token);
        localStorage.setItem("userName", res.data.user.name);
        localStorage.setItem("userEmail", res.data.user.email);

        setStatus({
          loading: false,
          ok: true,
          message: "Your email has been verified!",
        });

        // Redirect after a short delay
        setTimeout(() => {
          navigate("/my-orders");
        }, 1500);
      } catch (err) {
        console.error("Email verification error:", err);
        setStatus({
          loading: false,
          ok: false,
          message:
            err.response?.data?.error ||
            "Verification link is invalid or expired.",
        });
      }
    }

    verifyEmail();
  }, [API_BASE, searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 pt-20">
      <div className="max-w-sm w-full bg-white rounded-2xl shadow-md border border-gray-100 p-6 text-center">
        <h1 className="text-xl font-semibold mb-2">
          {status.loading
            ? "Verifying..."
            : status.ok
            ? "Email verified"
            : "Verification failed"}
        </h1>

        <p
          className={`text-sm ${
            status.ok ? "text-emerald-700" : "text-gray-600"
          }`}
        >
          {status.message}
        </p>
      </div>
    </div>
  );
}
